import './RoutineGoal.css';
import React from "react";

function RoutineGoal(props) {
    return (
        <div>
            <div className="routineRow">
            <div className="routineCircleLine"></div>     
                <div className="routineCircleRow">
                    <div className="routineCircle"></div>
                    <div className="routineCircle"></div>
                    <div className="routineCircle"></div>
                    <div className="routineCircle"></div>
                    <div className="routineCircle"></div>
                    <div className="routineCircle"></div>
                    <div className="routineCircle"></div>
                </div>      
            </div> 
            <div className="routineRowBottom">
            <div className="routineCircleLine"></div>     
                <div className="routineCircleRow">
                    <div className="routineCircle"></div>
                    <div className="routineCircle"></div>
                    <div className="routineCircle"></div>
                    <div className="routineCircle"></div>
                    <div className="routineCircle"></div>
                    <div className="routineCircle"></div>
                    <div className="routineCircle"></div>
                </div>        
            </div>

        </div>
    )
}

export default RoutineGoal;